<template>
  <v-container class="page-content px-5" style="width: 100%">
    <v-card>
      <v-toolbar
        class="removeBtnPaddingRight rounded-t-lg"
        color="#DADADA"
        flat
        dense
      >
        <v-btn
          @click="returnParent()" class="ml-n1 black--text" icon small
        >
          <v-icon>arrow_back</v-icon>
        </v-btn>
        <v-tabs v-model="tab">
          <v-tab href="#tab-1">
            <v-icon left>
              article
            </v-icon>
            История заявки
          </v-tab>
          <v-tab href="#tab-2">
            <v-icon left>
              fact_check
            </v-icon>
            Журнал событий
          </v-tab>
        </v-tabs>
      </v-toolbar>
      <v-card-text class="pa-0">
        <v-tabs-items v-model="tab">
          <v-tab-item
            :key="1"
            :value="'tab-1'"
          >
              <StatusLogList></StatusLogList>
          </v-tab-item>
          <v-tab-item
            :key="2"
            :value="'tab-2'"
          >
              <GuardLogList></GuardLogList>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>

import TitledPageMixin from "@/mixins/TitledPageMixin";
import names from "@/modules/entitled/routers/names";
import entitled from "@/urls/roles/entitled";
import names_core from "@/modules/core/routers/names";
import GuardLogList from "@/modules/entitled/orders/components/GuardLogList";
import StatusLogList from "@/modules/entitled/orders/components/StatusLogList";

export default {
  name: "EntitledOrdersLog",
  components: { GuardLogList, StatusLogList },
  mixins: [TitledPageMixin],
  data() {
    return {
      page_title: "Журнал логирования",
      tab: null
    }
  },
  watch: {},
  computed: {},
  methods: {
    returnParent() {
      this.$router.push({name: names.ORDERS.LIST}).catch(() => {})
    }
  },
  created() {
    if (!entitled.ENTITLED.ALLOWED()){
      this.$router.push({name: names_core.MAIN}).catch(() => {})
    }
  }
}
</script>

<style scoped>

</style>
